/**
 * Transport Buttons — shared play/pause/stop icon buttons used by
 * the Animation behavior editor and the Clip Editor timeline.
 */

import React from 'react';

export interface TransportButtonsProps {
    isPlaying: boolean;
    onPlayPause: () => void;
    onStop: () => void;
    disabled?: boolean;
}

const SIZE = 26;
const ICON = 12;

const btnStyle = (bg: string, isDisabled: boolean): React.CSSProperties => ({
    width: `${SIZE}px`,
    height: `${SIZE}px`,
    padding: 0,
    backgroundColor: bg,
    border: 'none',
    borderRadius: '3px',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    flexShrink: 0,
    opacity: isDisabled ? 0.5 : 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const PlayIcon = () => (
    <svg width={ICON} height={ICON} viewBox="0 0 12 12">
        <polygon points="2,0 12,6 2,12" fill="#fff" />
    </svg>
);

const PauseIcon = () => (
    <svg width={ICON} height={ICON} viewBox="0 0 12 12">
        <rect x="1" y="0" width="3.5" height="12" rx="0.5" fill="#fff" />
        <rect x="7.5" y="0" width="3.5" height="12" rx="0.5" fill="#fff" />
    </svg>
);

const StopIcon = () => (
    <svg width={ICON} height={ICON} viewBox="0 0 12 12">
        <rect x="1" y="1" width="10" height="10" rx="1" fill="#fff" />
    </svg>
);

export const TransportButtons: React.FC<TransportButtonsProps> = ({
    isPlaying, onPlayPause, onStop, disabled = false,
}) => (
    <div style={{ display: 'flex', gap: '4px' }}>
        <button
            onClick={onPlayPause}
            disabled={disabled}
            style={btnStyle(isPlaying ? '#ff9800' : '#4caf50', disabled)}
            title={isPlaying ? 'Pause' : 'Play'}
        >
            {isPlaying ? <PauseIcon /> : <PlayIcon />}
        </button>
        <button
            onClick={onStop}
            disabled={disabled && !isPlaying}
            style={btnStyle('#555', disabled && !isPlaying)}
            title="Stop"
        >
            <StopIcon />
        </button>
    </div>
);
